/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcknowledgeDeviceAuthTokenBody
} from './model/acknowledgeDeviceAuthTokenBody.js';

import type {
  DevLogin200
} from './model/devLogin200.js';

import type {
  DevLoginBody
} from './model/devLoginBody.js';

import type {
  ErrorEnvelope
} from './model/errorEnvelope.js';

import type {
  GetAuthSettings200
} from './model/getAuthSettings200.js';

import type {
  GetAuthStatus200
} from './model/getAuthStatus200.js';

import type {
  ListAuthIdentities200
} from './model/listAuthIdentities200.js';

import type {
  Logout200
} from './model/logout200.js';

import type {
  PollDeviceAuthToken200
} from './model/pollDeviceAuthToken200.js';

import type {
  PollDeviceAuthTokenBody
} from './model/pollDeviceAuthTokenBody.js';

import type {
  StartDeviceAuth201
} from './model/startDeviceAuth201.js';

import type {
  StartDeviceAuthBody
} from './model/startDeviceAuthBody.js';

import type {
  UnlinkAuthIdentity200
} from './model/unlinkAuthIdentity200.js';

import type {
  UpdateAuthSettings200
} from './model/updateAuthSettings200.js';

import type {
  UpdateAuthSettingsBody
} from './model/updateAuthSettingsBody.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Sign in with development credentials
 */
export const devLogin = (
    devLoginBody: DevLoginBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<DevLogin200>(
      {url: `/auth/dev-login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: devLoginBody, signal
    },
      options);
    }




export const getDevLoginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devLogin>>, TError,{data: DevLoginBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devLogin>>, TError,{data: DevLoginBody}, TContext> => {

const mutationKey = ['devLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devLogin>>, {data: DevLoginBody}> = (props) => {
          const {data} = props ?? {};

          return  devLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevLoginMutationResult = NonNullable<Awaited<ReturnType<typeof devLogin>>>
    export type DevLoginMutationBody = DevLoginBody
    export type DevLoginMutationError = unknown

    /**
 * @summary Sign in with development credentials
 */
export const useDevLogin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devLogin>>, TError,{data: DevLoginBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof devLogin>>,
        TError,
        {data: DevLoginBody},
        TContext
      > => {
      return useMutation(getDevLoginMutationOptions(options));
    }
    /**
 * Idempotently erases the encrypted handoff after the client has durably stored the returned API key.
 * @summary Acknowledge that a device credential was saved.
 */
export const acknowledgeDeviceAuthToken = (
    acknowledgeDeviceAuthTokenBody: AcknowledgeDeviceAuthTokenBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/auth/device/acknowledge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acknowledgeDeviceAuthTokenBody, signal
    },
      options);
    }




export const getAcknowledgeDeviceAuthTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgeDeviceAuthToken>>, TError,{data: AcknowledgeDeviceAuthTokenBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acknowledgeDeviceAuthToken>>, TError,{data: AcknowledgeDeviceAuthTokenBody}, TContext> => {

const mutationKey = ['acknowledgeDeviceAuthToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acknowledgeDeviceAuthToken>>, {data: AcknowledgeDeviceAuthTokenBody}> = (props) => {
          const {data} = props ?? {};

          return  acknowledgeDeviceAuthToken(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcknowledgeDeviceAuthTokenMutationResult = NonNullable<Awaited<ReturnType<typeof acknowledgeDeviceAuthToken>>>
    export type AcknowledgeDeviceAuthTokenMutationBody = AcknowledgeDeviceAuthTokenBody
    export type AcknowledgeDeviceAuthTokenMutationError = unknown

    /**
 * @summary Acknowledge that a device credential was saved.
 */
export const useAcknowledgeDeviceAuthToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgeDeviceAuthToken>>, TError,{data: AcknowledgeDeviceAuthTokenBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acknowledgeDeviceAuthToken>>,
        TError,
        {data: AcknowledgeDeviceAuthTokenBody},
        TContext
      > => {
      return useMutation(getAcknowledgeDeviceAuthTokenMutationOptions(options));
    }
    /**
 * @summary Start a device sign-in and return the device and user codes.
 */
export const startDeviceAuth = (
    startDeviceAuthBody: StartDeviceAuthBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<StartDeviceAuth201>(
      {url: `/auth/device/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startDeviceAuthBody, signal
    },
      options);
    }




export const getStartDeviceAuthMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startDeviceAuth>>, TError,{data: StartDeviceAuthBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startDeviceAuth>>, TError,{data: StartDeviceAuthBody}, TContext> => {

const mutationKey = ['startDeviceAuth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startDeviceAuth>>, {data: StartDeviceAuthBody}> = (props) => {
          const {data} = props ?? {};

          return  startDeviceAuth(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartDeviceAuthMutationResult = NonNullable<Awaited<ReturnType<typeof startDeviceAuth>>>
    export type StartDeviceAuthMutationBody = StartDeviceAuthBody
    export type StartDeviceAuthMutationError = unknown

    /**
 * @summary Start a device sign-in and return the device and user codes.
 */
export const useStartDeviceAuth = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startDeviceAuth>>, TError,{data: StartDeviceAuthBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startDeviceAuth>>,
        TError,
        {data: StartDeviceAuthBody},
        TContext
      > => {
      return useMutation(getStartDeviceAuthMutationOptions(options));
    }
    /**
 * Responds 202 while approval is pending. On approval the minted API key remains replayable until the client acknowledges durable storage.
 * @summary Poll a device sign-in for its result.
 */
export const pollDeviceAuthToken = (
    pollDeviceAuthTokenBody: PollDeviceAuthTokenBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<PollDeviceAuthToken200>(
      {url: `/auth/device/token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pollDeviceAuthTokenBody, signal
    },
      options);
    }




export const getPollDeviceAuthTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pollDeviceAuthToken>>, TError,{data: PollDeviceAuthTokenBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pollDeviceAuthToken>>, TError,{data: PollDeviceAuthTokenBody}, TContext> => {

const mutationKey = ['pollDeviceAuthToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pollDeviceAuthToken>>, {data: PollDeviceAuthTokenBody}> = (props) => {
          const {data} = props ?? {};

          return  pollDeviceAuthToken(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PollDeviceAuthTokenMutationResult = NonNullable<Awaited<ReturnType<typeof pollDeviceAuthToken>>>
    export type PollDeviceAuthTokenMutationBody = PollDeviceAuthTokenBody
    export type PollDeviceAuthTokenMutationError = unknown

    /**
 * @summary Poll a device sign-in for its result.
 */
export const usePollDeviceAuthToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pollDeviceAuthToken>>, TError,{data: PollDeviceAuthTokenBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pollDeviceAuthToken>>,
        TError,
        {data: PollDeviceAuthTokenBody},
        TContext
      > => {
      return useMutation(getPollDeviceAuthTokenMutationOptions(options));
    }
    /**
 * @summary List linked authentication identities
 */
export const listAuthIdentities = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAuthIdentities200>(
      {url: `/auth/identities`, method: 'GET', signal
    },
      options);
    }




export const getListAuthIdentitiesQueryKey = () => {
    return [
    `/auth/identities`
    ] as const;
    }


export const getListAuthIdentitiesQueryOptions = <TData = Awaited<ReturnType<typeof listAuthIdentities>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuthIdentities>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuthIdentitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuthIdentities>>> = ({ signal }) => listAuthIdentities(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuthIdentities>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAuthIdentitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listAuthIdentities>>>
export type ListAuthIdentitiesQueryError = unknown


/**
 * @summary List linked authentication identities
 */

export function useListAuthIdentities<TData = Awaited<ReturnType<typeof listAuthIdentities>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuthIdentities>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAuthIdentitiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Unlink an authentication identity
 */
export const unlinkAuthIdentity = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<UnlinkAuthIdentity200>(
      {url: `/auth/identities/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getUnlinkAuthIdentityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkAuthIdentity>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkAuthIdentity>>, TError,{id: string}, TContext> => {

const mutationKey = ['unlinkAuthIdentity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkAuthIdentity>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  unlinkAuthIdentity(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkAuthIdentityMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkAuthIdentity>>>

    export type UnlinkAuthIdentityMutationError = unknown

    /**
 * @summary Unlink an authentication identity
 */
export const useUnlinkAuthIdentity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkAuthIdentity>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unlinkAuthIdentity>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUnlinkAuthIdentityMutationOptions(options));
    }
    /**
 * @summary Sign out the current session
 */
export const logout = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Logout200>(
      {url: `/auth/logout`, method: 'POST', signal
    },
      options);
    }




export const getLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = unknown

    /**
 * @summary Sign out the current session
 */
export const useLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options));
    }
    /**
 * @summary Get current authentication status
 */
export const getAuthStatus = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetAuthStatus200>(
      {url: `/auth/me`, method: 'GET', signal
    },
      options);
    }




export const getGetAuthStatusQueryKey = () => {
    return [
    `/auth/me`
    ] as const;
    }


export const getGetAuthStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAuthStatus>>, TError = ErrorEnvelope>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthStatus>>> = ({ signal }) => getAuthStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuthStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthStatus>>>
export type GetAuthStatusQueryError = ErrorEnvelope


/**
 * @summary Get current authentication status
 */

export function useGetAuthStatus<TData = Awaited<ReturnType<typeof getAuthStatus>>, TError = ErrorEnvelope>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuthStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get authentication settings
 */
export const getAuthSettings = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetAuthSettings200>(
      {url: `/auth/settings`, method: 'GET', signal
    },
      options);
    }




export const getGetAuthSettingsQueryKey = () => {
    return [
    `/auth/settings`
    ] as const;
    }


export const getGetAuthSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAuthSettings>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthSettings>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthSettings>>> = ({ signal }) => getAuthSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuthSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthSettings>>>
export type GetAuthSettingsQueryError = unknown


/**
 * @summary Get authentication settings
 */

export function useGetAuthSettings<TData = Awaited<ReturnType<typeof getAuthSettings>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthSettings>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuthSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update authentication settings
 */
export const updateAuthSettings = (
    updateAuthSettingsBody: UpdateAuthSettingsBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<UpdateAuthSettings200>(
      {url: `/auth/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAuthSettingsBody, signal
    },
      options);
    }




export const getUpdateAuthSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAuthSettings>>, TError,{data: UpdateAuthSettingsBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAuthSettings>>, TError,{data: UpdateAuthSettingsBody}, TContext> => {

const mutationKey = ['updateAuthSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAuthSettings>>, {data: UpdateAuthSettingsBody}> = (props) => {
          const {data} = props ?? {};

          return  updateAuthSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAuthSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAuthSettings>>>
    export type UpdateAuthSettingsMutationBody = UpdateAuthSettingsBody
    export type UpdateAuthSettingsMutationError = unknown

    /**
 * @summary Update authentication settings
 */
export const useUpdateAuthSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAuthSettings>>, TError,{data: UpdateAuthSettingsBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAuthSettings>>,
        TError,
        {data: UpdateAuthSettingsBody},
        TContext
      > => {
      return useMutation(getUpdateAuthSettingsMutationOptions(options));
    }
